import React from "react";
import TextBaseV2 from "../../textBaseV2/TextBaseV2";
import { useTranslation } from "react-i18next";

function HeaderListTableBuyTicket() {
  const { t } = useTranslation();

  return (
    <div className="grid w-full grid-rows-3 md:pb-4 md:grid-rows-none md:grid-cols-12 gap-x-3 gap-y-4 lg:gap-y-3 md:gap-y-0">
      <div className="flex items-center col-span-1 md:col-span-4 md:grid lg:col-span-5">
        <p className={" text-body-1 text-neutral-900 md:text-neutral-500"}>
          {t("ticket_type")}
        </p>
      </div>
      <div className="flex items-center col-span-1 md:col-span-3 md:grid ">
        <p
          className={
            " text-body-1 text-neutral-900 md:text-neutral-500 md:text-center"
          }
        >
          {t("quantity")}
        </p>
      </div>
      <div className="flex items-center col-span-1 md:col-span-4 md:grid lg:col-span-3">
        <p className={" text-body-1 text-neutral-900 md:text-neutral-500"}>
          {t("unit_price")}
        </p>
      </div>
    </div>
  );
}

export default HeaderListTableBuyTicket;
